import { render, staticRenderFns } from "./CustomToggle.vue?vue&type=template&id=482def2a&scoped=true&"
import script from "./CustomToggle.vue?vue&type=script&lang=js&"
export * from "./CustomToggle.vue?vue&type=script&lang=js&"
import style0 from "./CustomToggle.vue?vue&type=style&index=0&id=482def2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482def2a",
  null
  
)

export default component.exports